import { createFileRoute } from '@tanstack/react-router';
import JobsLandingPage from 'src/Jobs/JobsLandingPage';
import { requireAuth } from 'src/utils/authGuard';

export const Route = createFileRoute('/jobs')({
  beforeLoad: () => {
    requireAuth();
  },
  component: JobsLandingPage,
});
